import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getBalanceOverview = (
  accountId?: number,
  signal?: AbortSignal
) => {
  return axiosPrivate.get('/dashboard/v2/balance/overview', {
    params: { accountId },
    signal,
  });
};

export const getBalanceReports = (signal?: AbortSignal) => {
  return axiosPrivate.get('/dashboard/v2/transfers/reports', {
    signal,
  });
};

export const downloadBalanceReport = (reportId: number) => {
  return axiosPrivate.get(
    `/dashboard/v2/transfers/reports/${reportId}/download`,
    {
      responseType: 'blob',
    }
  );
};
